"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sx2CssThemeFn = void 0;
const css_1 = __importDefault(require("@styled-system/css"));
const merge_1 = __importDefault(require("lodash/merge"));
function sx2CssThemeFn(...sxs) {
    return props => (0, css_1.default)((0, merge_1.default)({}, ...sxs.map(sx => (typeof sx === 'function' ? sx(props) : sx))))(props.theme);
}
exports.sx2CssThemeFn = sx2CssThemeFn;
function sx2CssTheme(theme, ...sxs) {
    if (sxs.length === 1) {
        return (0, css_1.default)(sxs[0])(theme);
    }
    return (0, css_1.default)((0, merge_1.default)({}, ...sxs))(theme);
}
exports.default = sx2CssTheme;
//# sourceMappingURL=sx2CssTheme.js.map